
<div class="modal-body">
    <img style="display: block;
    margin-left: 47%;
    margin-bottom: 2%;
    margin-right: auto;
    max-width: 80%;" src="assets\images\Iamvideo\loadingSpinner.gif" />
</div>